export const RANK_TYPE = [
    { key: 101, value: "보유 NFT 스탯 총합" },
    { key: 102, value: "보유 NFT 레벨 총합" },
    { key: 103, value: "보유 NFT 개수(등급별)" },
    { key: 201, value: "NFT 스탯 합계" },
    { key: 202, value: "NFT 스피드" },
    { key: 203, value: "NFT 럭" },
    { key: 204, value: "NFT 에너지" },
    { key: 205, value: "NFT 듀러빌리티" },
    { key: 301, value: "월간 계정 PER 채굴" },
    { key: 302, value: "월간 계정 XPER 채굴" },
    { key: 303, value: "월간 계정 마켓 NFT 판매" },
    { key: 304, value: "월간 계정 마켓 아이템 판매" },
    { key: 401, value: "월간 NFT PER 채굴" },
    { key: 402, value: "월간 NFT XPER 채굴" },
    { key: 501, value: "게임 주간 랭킹" },
    { key: 502, value: "게임 월간 랭킹" },
    { key: 601, value: "브리딩 랭킹" },
    { key: 602, value: "아이템 보유 수량" },
    { key: 603, value: "노말 이볼브 랭킹"},
    { key: 604, value: "레어 이볼브 랭킹"},
    { key: 605, value: "엘리트 이볼브 랭킹"},
    { key: 611, value: "소켓 변경 랭킹"},
    { key: 612, value: "소켓 매칭 랭킹"},
    { key: 613, value: "NFT 레벨업 랭킹"},
    { key: 614, value: "엔진 워크샵 랭킹 - NFT 분해, 엔진 강화, 엔진 서포터 업그레이드"},
    { key: 701, value: "노말 차량 XPER 채굴 랭킹"},
    { key: 801, value: "파일럿 XPER 소비 랭킹"},
];

export function getRankTypeName(key){
    const type = RANK_TYPE?.find(item => item.key === key);
    return type ? type?.value : key;
}


export const RANK_TARGET_TYPE = [
    {key: 1, value: "계정"},
    {key: 2, value: "차량 NFT"},
    {key: 3, value: "앱 넘버"}
]

export function getRankTargetTypeName(key){
    const type = RANK_TARGET_TYPE?.find(item => item.key === key);
    return type ? type?.value : key;
}